window.countrySelectorConfig = {
  desktop: ".header-country-slot",
  mobile: ".drawer-country-slot"
};

(function (){
  const config = window.countrySelectorConfig;

  const MOBILE_QUERY = '(max-width: 767px)';
  const mq = window.matchMedia(MOBILE_QUERY);

  const selector = document.getElementById('country-selector-root');
  const headerContainer = document.querySelector(config.desktop);
  const drawerContainer = document.querySelector(config.mobile);

  if (!selector || !headerContainer || !drawerContainer) return;

  function place(e) {
    if (e.matches) {
      // Mobile
      if (!drawerContainer.contains(selector)) {
        drawerContainer.appendChild(selector);
      }
    } else {
      // Desktop
      if (!headerContainer.contains(selector)) {
        headerContainer.appendChild(selector);
      }
    }
  }

  // Initial run
  place(mq);

  // Listen only when breakpoint changes
  mq.addEventListener('change', place);
})()